import BaseService from './BaseService';

class AwareExposeService extends BaseService {
    publicConfig(key) {
        return this.get(`/public/aware-expose/${encodeURIComponent(key)}/config`);
    }

    publicScan(key, payload) {
        return this.post(
            `/public/aware-expose/${encodeURIComponent(key)}/scan`,
            payload
        );
    }

    publicAttacks(key, payload) {
        return this.post(
            `/public/aware-expose/${encodeURIComponent(key)}/attacks`,
            payload
        );
    }

    config(companyId) {
        return this.get('/aware-expose/config', { companyId });
    }

    lastRun(companyId) {
        return this.get('/aware-expose/runs/last', { companyId });
    }

    history(companyId, limit) {
        return this.get('/aware-expose/runs', { companyId, limit });
    }

    scan(companyId, person) {
        return this.post('/aware-expose/scan', { companyId, ...person });
    }

    attacks(companyId, runId) {
        return this.post('/aware-expose/attacks', { companyId, runId });
    }
}

export default AwareExposeService;
